import { AppRouter } from './routing';
import { Router } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StoreProvider } from 'easy-peasy';
import { WithConfigProvider } from './providers/WithConfigProvider';
import DatadogProvider from './providers/DatadogProvider';
import { store, history } from './store';
import { ReactQueryDevtoolsSuspense } from './components/ReactQueryDevtoolsSuspense';
import './App.less';
import { injections } from './store/services/injections';
import { SessionProvider } from './hooks/SessionProvider';

const queryClient = new QueryClient();

// Inject queryClient into the existing injections
injections.queryClient = queryClient;

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtoolsSuspense />
      <StoreProvider store={store}>
        <WithConfigProvider>
          <Router history={history}>
            <SessionProvider>
              <DatadogProvider>
                <AppRouter />
              </DatadogProvider>
            </SessionProvider>
          </Router>
        </WithConfigProvider>
      </StoreProvider>
    </QueryClientProvider>
  );
};

export default App;
